import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import store from '@state/store'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en',
  silentTranslationWarn: true, // to suppress "not loaded" messages at start of app
  messages: {}, // load locale messages dynamically
})
const loadedLanguages = [] // keep loaded languages to array to avoid re-importing messages

/**
 * @param {String} lang
 */
export function setI18nLanguage(lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

/**
 * @param {String} locale
 */
export async function loadMessages(locale) {
  // If the language was already loaded
  if (loadedLanguages.includes(locale)) {
    return Promise.resolve(setI18nLanguage(locale))
  }

  if (locale && Object.keys(i18n.getLocaleMessage(locale)).length === 0) {
    const messages = await import('@lang/' + locale)
    i18n.setLocaleMessage(locale, messages.default)
    loadedLanguages.push(locale)
  }
  return Promise.resolve(setI18nLanguage(locale))
}

/**
 * @param {String} lang
 */
export function loadLanguageAsync(lang) {
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language hasn't been loaded yet
  return import('@lang/' + lang).then((messages) => {
    i18n.setLocaleMessage(lang, messages.default)
    loadedLanguages.push(lang)
    return setI18nLanguage(lang)
  })
}

export function loadLocaleModules() {
  const locales = require.context('@lang', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

// on app load
;(async function () {
  await loadMessages(store.getters['auth/language'])
})()
